import { ActionContext, ActionTree } from 'vuex';
import LagerService from '@/modules/ewerp/service/LagerService';

import { RootState } from '@/modules/ewerp/store';
import { useEwerpCommonStore } from '@/modules/ewerp/store/ewerpCommonStore';

import { State } from './state';

import { Mutations, MutationTypes } from './mutations';


import { PlanungMaschinenHeute, Planung, Land, WritePlanungKommentarRequest } from '@/modules/ewerp/models/PlanungModels';

export enum ActionTypes {
  GetPlanung = 'GETPLANUNG',
  UpdateGetPlanung = 'UPDATEGETPLANUNG',
  GetProduktionsauftraegeDatum = 'GETPRODUKTIONSAUFTRAEGEDATUM',
  SilentGetProduktionsauftraegeDatum = 'SILENTGETPRODUKTIONSAUFTRAEGEDATUM',
  ClearPlanung = 'CLEARPLANUNG',
  GetAllLaender = 'GETALLLAENDER',
  WritePlanungKommentar = 'WRITEPLANUNGKOMMENTAR',
}

type ActionArguments = Omit<ActionContext<State, RootState>, 'commit'> & {
  commit<K extends keyof Mutations>(key: K, payload: Parameters<Mutations[K]>[1]): ReturnType<Mutations[K]>;
};

export type Actions = {
  [ActionTypes.GetPlanung](context: ActionArguments, maschinename: string): Promise<void>;
  [ActionTypes.UpdateGetPlanung](context: ActionArguments, maschinename: string): Promise<void>;
  [ActionTypes.GetProduktionsauftraegeDatum](context: ActionArguments, datum: string): Promise<void>;
  [ActionTypes.SilentGetProduktionsauftraegeDatum](context: ActionArguments, datum: string): Promise<void>;
  [ActionTypes.ClearPlanung](context: ActionArguments): void;
  [ActionTypes.GetAllLaender](context: ActionArguments): Promise<void>;
  [ActionTypes.WritePlanungKommentar](context: ActionArguments, data: WritePlanungKommentarRequest): Promise<void>;
};

export const actions: ActionTree<State, RootState> & Actions = {
  async [ActionTypes.GetPlanung]({ commit, dispatch }: ActionArguments, maschinename: string) {
    const commonStore = useEwerpCommonStore();
    const status = commonStore.status;
    status.planungLoading = true;
    commonStore.setStatus(status);
    dispatch(ActionTypes.ClearPlanung, undefined);

    // const listeppsidmaschinen = ['Linie 1', 'Linie 2', 'Linie 3', 'Linie 4', 'Linie 5'];
    const listeppsidmaschinen: string[] = [];

    // PPS-ID Maschinen, nicht mehr relevant, da ListePPSID nicht mehr existiert, nur noch der else-Fall, welcher Listeartikel verwendet
    // Kann zeitnah entfernt werden (datum: 07.01.2026)
    if (listeppsidmaschinen.includes(maschinename)) {
      return LagerService.getMaschinenPlanungHeute(maschinename)
        .then((res) => {
          status.planungLoading = false;
          commonStore.setStatus(status);

          const result: PlanungMaschinenHeute = res.data;
          commit(MutationTypes.GetPlanungSuccess, result.listePlanungResource);
          commit(MutationTypes.GetPalettenProStunde, result.anzahlListeartikelProStunde);
        })
        .catch((error) => {
          status.planungLoading = false;
          // console.log(error);
          if (error.message === 'Network Error') {
            status.planungErrorMsg = error.message;
          } else if (error.response?.status == 401) {
            status.planungErrorMsg = 'Sie haben keinen Zugriff auf diese Daten';
          } else {
            status.planungErrorMsg = error;
          }

          commonStore.setStatus(status);
        });
    } else {
      return LagerService.getMaschinenPlanungHeuteListeartikel(maschinename)
        .then((res) => {
          status.planungLoading = false;
          commonStore.setStatus(status);

          const result: PlanungMaschinenHeute = res.data;
          commit(MutationTypes.GetPlanungSuccess, result.listePlanungResource);
          commit(MutationTypes.GetPalettenProStunde, result.anzahlListeartikelProStunde);
        })
        .catch((error) => {
          status.planungLoading = false;
          // console.log(error);
          if (error.message === 'Network Error') {
            status.planungErrorMsg = error.message;
          } else if (error.response?.status == 401) {
            status.planungErrorMsg = 'Sie haben keinen Zugriff auf diese Daten';
          } else {
            status.planungErrorMsg = error;
          }

          commonStore.setStatus(status);
        });
    }
  },

  async [ActionTypes.UpdateGetPlanung]({ commit }: ActionArguments, maschinename: string) {
    const commonStore = useEwerpCommonStore();
    const status = commonStore.status;

    // const listeppsidmaschinen = ['Vodka', 'Gin', 'Kirsch', 'Putinoff', 'Rum'];
    const listeppsidmaschinen: string[] = [];

    if (listeppsidmaschinen.includes(maschinename)) {
      return LagerService.getMaschinenPlanungHeute(maschinename)
        .then((res) => {
          const result: PlanungMaschinenHeute = res.data;
          commit(MutationTypes.GetPlanungSuccess, result.listePlanungResource);
          commit(MutationTypes.GetPalettenProStunde, result.anzahlListeartikelProStunde);
        })
        .catch((error) => {
          // console.log(error);
          if (error.message === 'Network Error') {
            status.planungErrorMsg = error.message;
          } else if (error.response?.status == 401) {
            status.planungErrorMsg = 'Sie haben keinen Zugriff auf diese Daten';
          } else {
            status.planungErrorMsg = error;
          }

          commonStore.setStatus(status);
        });
    } else {
      return LagerService.getMaschinenPlanungHeuteListeartikel(maschinename)
        .then((res) => {
          const result: PlanungMaschinenHeute = res.data;
          commit(MutationTypes.GetPlanungSuccess, result.listePlanungResource);
          commit(MutationTypes.GetPalettenProStunde, result.anzahlListeartikelProStunde);
        })
        .catch((error) => {
          // console.log(error);
          if (error.message === 'Network Error') {
            status.planungErrorMsg = error.message;
          } else if (error.response?.status == 401) {
            status.planungErrorMsg = 'Sie haben keinen Zugriff auf diese Daten';
          } else {
            status.planungErrorMsg = error;
          }

          commonStore.setStatus(status);
        });
    }
  },

  async [ActionTypes.GetProduktionsauftraegeDatum]({ commit }: ActionArguments, datum: string) {
    const commonStore = useEwerpCommonStore();
    const status = commonStore.status;
    status.planungLoading = true;
    status.planungErrorMsg = '';
    commonStore.setStatus(status);

    return LagerService.getProduktionsauftraegeDatum(datum)
      .then((res) => {
        const result: Array<Planung> = res.data;
        commit(MutationTypes.SetProduktionsauftraege, result);
      })
      .catch((error) => {
        if (error.message === 'Network Error') {
          status.planungErrorMsg = error.message;
        } else if (error.response?.status == 401) {
          status.planungErrorMsg = 'Sie haben keinen Zugriff auf diese Daten';
        } else {
          status.planungErrorMsg = error;
        }
      })
      .finally(() => {
        status.planungLoading = false;
        commonStore.setStatus(status);
      });
  },

  async [ActionTypes.SilentGetProduktionsauftraegeDatum]({ commit }: ActionArguments, datum: string) {
    const commonStore = useEwerpCommonStore();
    const status = commonStore.status;
    status.planungErrorMsg = '';
    commonStore.setStatus(status);

    return LagerService.getProduktionsauftraegeDatum(datum)
      .then((res) => {
        const result: Array<Planung> = res.data;
        commit(MutationTypes.SetProduktionsauftraege, result);
      })
      .catch((error) => {
        if (error.message === 'Network Error') {
          status.planungErrorMsg = error.message;
        } else if (error.response?.status == 401) {
          status.planungErrorMsg = 'Sie haben keinen Zugriff auf diese Daten';
        } else {
          status.planungErrorMsg = error;
        }
      })
      .finally(() => {
        commonStore.setStatus(status);
      });
  },

  async [ActionTypes.WritePlanungKommentar]({ commit }: ActionArguments, data: WritePlanungKommentarRequest) {
    const commonStore = useEwerpCommonStore();
    const status = commonStore.status;
    status.updatePlanungLoading = true;
    status.planungErrorMsg = '';
    commonStore.setStatus(status);

    return LagerService.writePlanungKommentar(data)
      .then((res) => {
        const result: Planung = res.data;
        commit(MutationTypes.UpdateProduktionsauftrag, result);
      })
      .catch((error) => {
        // console.log(error);
        if (error.message === 'Network Error') {
          status.planungErrorMsg = error.message;
        } else if (error.response?.status == 400) {
          status.planungErrorMsg = error.response.data.title || 'Fehler beim Speichern des Kommentars';
        } else if (error.response?.status == 401) {
          status.planungErrorMsg = 'Sie haben keinen Zugriff auf diese Daten';
        } else {
          status.planungErrorMsg = error;
        }
      })
      .finally(() => {
        status.updatePlanungLoading = false;
        commonStore.setStatus(status);
      });
  },

  [ActionTypes.ClearPlanung]({ commit }: ActionArguments) {
    commit(MutationTypes.ClearPlanung, undefined);
  },

  async [ActionTypes.GetAllLaender]({ commit }: ActionArguments) {
    const commonStore = useEwerpCommonStore();
    const status = commonStore.status;
    status.landLoading = true;
    status.landErrorMsg = '';
    commonStore.setStatus(status);

    return LagerService.getAllLaender()
      .then((res) => {
        const result: Array<Land> = res.data;
        commit(MutationTypes.SetLaender, result);
      })
      .catch((error) => {
        if (error.message === 'Network Error') {
          status.landErrorMsg = error.message;
        } else if (error.response?.status == 401) {
          status.landErrorMsg = 'Sie haben keinen Zugriff auf diese Daten';
        } else {
          status.landErrorMsg = error;
        }
      })
      .finally(() => {
        status.landLoading = false;
        commonStore.setStatus(status);
      });
  },
};
